import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Pagination from '@components/@core/Pagination';
import CommunityBlogs from '@components/BlogFeed/CommunityBlogs';
import CommunitySlider from '@components/CommunitySlider';
import DepartmentForum from '@components/DepartmentForum';
import FeaturedDepartments from '@components/FeaturedDepartments';
import PremiumBlogs from '@components/BlogFeed/PremiumBlogs';
import RecentDepartment from '@components/RecentDepartment';
import RecentForum from '@components/RecentForum';
import { AppActions, CommunityActions, CompanyActions, VendorActions } from '~/actions';
import CommunityHeader from '~/views/Community/Community/Header';

class Home extends Component {
    state = { adsData: [], departments: [], featuredItems: this.props.featuredItems };

    componentDidMount() {
        const adsData = [];
        window.broadstreetNative = (el, ads) => {
            adsData.push(ads);
            this.setState({ adsData });
        };
        // 1st
        this.props.getFeaturedItems();
    }

    componentDidUpdate(prevProps) {
        if (this.props.featuredItems !== prevProps.featuredItems) {
            this.props.getTopics({ order: 'recent' });
            // 2nd
            const { authenticated } = this.props.authenticated;
            if (authenticated) {
                this.props.getBlogs({
                    userId: props.user?.community_user?.id,
                    slug: props.user?.community_user?.entity?.slug,
                });
            }
            this.props.getBlogPosts({ exclusive: 1, perPage: 9, page: 1 }, 'premium');
            this.props.getBlogPosts({ exclusive: 0, perPage: 9, page: 1 }, 'community');
            // 3rd
            this.props.getDepartments();
            this.props.getAllTopics();
            this.props.getCategories();
        }
    }

    handleMenu = (event, item, page, perPage) => {
        if (event === 'edit') {
            this.props.toggleModal({
                type: 'Add Forum',
                data: { before: { topic: item, event, page, perPage } },
            });
        }
    };

    handleProductDetail = (product, categoryId) => {
        const { parent } = product;
        if (parent.business_id) {
            const payload = { id: parent.business_id };
            const route = {
                pathname: `/business/${product.slug}`,
                search: `?id=${parent.business_id}&category=${categoryId}`,
            };
            this.props.getBusiness(payload, route);
        } else {
            toast.error('This product does not have business yet. Please reach out to Brandon!', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
        }
    };

    handlePagination = (page, perPage = 10) => {
        this.props.getBlogPosts({ exclusive: 0, page, perPage }, 'community');
    };

    render() {
        const { adsData } = this.state;
        const { blogs, departments, featuredItems, userRole, userName, topics } = this.props;
        const premiumPosts = blogs?.premium?.posts?.data ?? [];
        const communityPosts = blogs?.community?.posts?.data ?? [];

        return (
            <ErrorBoundary className="community-home">
                <Helmet>
                    <title>Dealership best practices, news and announcements. Automotive Blogs | DrivingSales</title>
                    <meta name="description" content="Dealership best practices, news and announcements. Automotive Blogs | DrivingSales" />
                </Helmet>
                <broadstreet-zone zone-id="99535"></broadstreet-zone>
                <CommunityHeader activeRoute="Home" activeRouteUrl="community/home" />
                <CommunitySlider className="home-carousel" data={featuredItems} adsList={adsData} />
                <div className="d-flex ssm-column px-1 px-md-0">
                    <div className="d-flex-1 me-2 ssm-r-0">
                        <FeaturedDepartments title="Featured CRM" onProductDetail={(product, categoryId) => this.handleProductDetail(product, categoryId)} loading={false} />
                        {premiumPosts.length > 0 && <PremiumBlogs adsList={adsData} data={premiumPosts} title="Premium Blogs" loading={false} />}
                        {communityPosts.length > 0 && <CommunityBlogs adsList={adsData} data={communityPosts} title="Community Blogs" loading={false} />}
                        {blogs?.community?.posts?.current_page && (
                            <Pagination
                                current={blogs?.community?.posts?.current_page}
                                pers={[]}
                                per={blogs?.community?.posts?.per_page}
                                total={blogs?.community?.posts?.last_page}
                                onChange={(e) => this.handlePagination(e)}
                            />
                        )}
                    </div>
                    <div className="d-flex-1 ms-2">
                        <RecentForum title="Forum Activity" adsList={adsData} recentTopic={topics?.topics?.data || []} displayMenu loading={false} />
                        {departments.length > 0 && (
                            <>
                                <DepartmentForum title="Department Forums" departments={departments} loading={false} />
                                {departments.map((department, index) => (
                                    <RecentDepartment key={index} index={index} adsData={adsData[index % adsData.length]} department={department} />
                                ))}
                            </>
                        )}
                    </div>
                </div>
            </ErrorBoundary>
        );
    }
}

Home.propTypes = {
    authenticated: PropTypes.string,
    user: PropTypes.shape({ id: PropTypes.number }),
    userName: PropTypes.string,
    userRole: PropTypes.number,
    departments: PropTypes.array,
    featuredItems: PropTypes.array,
};

Home.defaultProps = {
    authenticated: '',
    user: { id: 0 },
    userName: '',
    userRole: 5,
    departments: [],
    featuredItems: [],
};

const mapStateToProps = (state) => ({
    authenticated: state.app.token,
    user: state.app.user,
    userName: state.app.user_name,
    userRole: state.app.app_role_id,
    departments: state.company.blogCategories,
    featuredItems: state.community.featuredItems,
    topics: state.community.topics['all'],
    blogs: state.community.blogs,
});

const mapDispatchToProps = (dispatch) => ({
    getBlogs: (payload) => dispatch(CommunityActions.getcommunityblogRequest(payload)),
    getBlogPosts: (e, type) => dispatch(CommunityActions.getcomblogpostsRequest(e, type)),
    getBusiness: (payload, route) => dispatch(CompanyActions.getbusinessRequest(payload, route, false)),
    getCategories: () => dispatch(VendorActions.getcategoriesRequest()),
    getDepartments: () => dispatch(CompanyActions.getblogcategoriesRequest()),
    getEditFeaturedItems: (type, e) => dispatch(CommunityActions.geteditfeatureditemsRequest(type, e, null, false)),
    getFeaturedItems: () => dispatch(CommunityActions.getfeatureditemsRequest()),
    getTopics: (e) => dispatch(CommunityActions.gettopicsRequest(e, false)),
    getAllTopics: () => dispatch(CommunityActions.getalldepartmentforumtopicsRequest()),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
